import { DatePipe, DecimalPipe } from '@angular/common';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { IntlService } from '@progress/kendo-angular-intl';
import { MessageService } from '@progress/kendo-angular-l10n';
import { CookiesService } from '@shared/cookies/cookies.service';
import { EngineCultureService } from '@core/engine-culture/services/culture.service';
import { KENDO_LOCALE_ID, KendoIntlService } from './services/kendo-intl.service';
import { KendoMessageService } from './services/kendo-message.service';

export function provideKendoCore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    DecimalPipe,
    DatePipe,
    KendoMessageService,
    { provide: MessageService, useClass: KendoMessageService },
    { provide: IntlService, useClass: KendoIntlService },
    {
      provide: KENDO_LOCALE_ID,
      useFactory: (cultureService: EngineCultureService) => {
        const allowedLocale = ['en', 'pl', 'uk'];
        let localeId = 'en';
        try {
          localeId = cultureService.localeData[0] ?? localeId;
        } catch (_) {}
        return allowedLocale.includes(localeId) ? localeId : 'en';
      },
      deps: [EngineCultureService, CookiesService],
    },
  ]);
}
